import axios from 'axios';
import router from '../router';

const TOKEN_REFRESH_INTERVAL = 1000 * 60 * 25; // 25 minutes
const SESSION_TIMEOUT = 1000 * 60 * 60; // 1 hour

export default {
  namespaced: true,
  state: {
    isAuthenticated: false,
    accessToken: null,
    refreshToken: null,
    reference: null,
    refreshTokenInterval: null,
    activityTimeout: null,
    lastActivity: Date.now()
  },
  mutations: {
    setAuth(state, { accessToken, refreshToken, reference }) {
      state.isAuthenticated = true;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      state.reference = reference;
      localStorage.setItem('accessToken', accessToken);
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('reference', reference);
      localStorage.setItem('isLoggedIn', 'true');
      axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    },
    clearAuth(state) {
      state.isAuthenticated = false;
      state.accessToken = null;
      state.refreshToken = null;
      state.reference = null;
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      localStorage.removeItem('reference');
      localStorage.removeItem('isLoggedIn');
      delete axios.defaults.headers.common['Authorization'];
    },
    setRefreshInterval(state, interval) {
      if (state.refreshTokenInterval) {
        clearInterval(state.refreshTokenInterval);
      }
      state.refreshTokenInterval = interval;
    },
    setActivityTimeout(state, timeout) {
      if (state.activityTimeout) {
        clearTimeout(state.activityTimeout);
      }
      state.activityTimeout = timeout;
    },
    updateLastActivity(state) {
      state.lastActivity = Date.now();
    }
  },
  actions: {
    async login({ commit, dispatch }, { username, password }) {
      const response = await axios.post('public/auth/login', {
        username,
        password,
      });

      const { accessToken, refreshToken, reference } = response.data;
      
      commit('setAuth', { accessToken, refreshToken, reference });
      dispatch('startTokenRefresh');
      dispatch('startActivityMonitor');
      
      return response;
    },
    
    logout({ commit, state }) {
      if (state.refreshTokenInterval) {
        clearInterval(state.refreshTokenInterval);
      }
      if (state.activityTimeout) {
        clearTimeout(state.activityTimeout);
      }
      commit('clearAuth');
      router.push('/');
    },
    
    async refreshToken({ commit, state, dispatch }) {
      try {
        if (!state.refreshToken) return;
        
        const response = await axios.post('public/auth/new-access-token', {
          refreshToken: state.refreshToken,
        });

        const { accessToken } = response.data;
        commit('setAuth', {
          accessToken,
          refreshToken: state.refreshToken,
          reference: state.reference
        });
      } catch (error) {
        console.error('Token refresh failed:', error);
        dispatch('logout');
      }
    },
    
    startTokenRefresh({ commit, dispatch }) {
      const interval = setInterval(() => {
        dispatch('refreshToken');
      }, TOKEN_REFRESH_INTERVAL);
      
      commit('setRefreshInterval', interval);
    },
    
    startActivityMonitor({ commit, dispatch, state }) {
      const checkActivity = () => {
        const now = Date.now();
        if (now - state.lastActivity > SESSION_TIMEOUT) {
          dispatch('logout');
        } else {
          const timeout = setTimeout(checkActivity, 60000); // Check every minute
          commit('setActivityTimeout', timeout);
        }
      };
      
      checkActivity();
    },
    
    updateActivity({ commit }) {
      commit('updateLastActivity');
    },
    
    initializeFromStorage({ commit, dispatch }) {
      const accessToken = localStorage.getItem('accessToken');
      const refreshToken = localStorage.getItem('refreshToken');
      const reference = localStorage.getItem('reference');
      const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';
      
      if (isLoggedIn && accessToken && refreshToken) {
        commit('setAuth', { accessToken, refreshToken, reference });
        dispatch('startTokenRefresh');
        dispatch('startActivityMonitor');
      }
    }
  }
};